import React, { useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { motion } from "framer-motion";

interface ListQuestionsFaqProps {
  faq: any;
}

const ListQuestionsFaq: React.FC<ListQuestionsFaqProps> = (props) => {
  const [questionSelected, setQuestionSelected] = useState<any>(null);

  const changeQuestion = (id: any) => {
    setQuestionSelected(questionSelected === id ? null : id);
  };

  return (
    <>
      {props.faq?.faqs?.map((item: any, index: any) => (
        <motion.div
          key={index}
          onClick={() => changeQuestion(item.id)}
          className="w-full bg-primary-50 rounded-lg shadow-xl px-10 py-5 cursor-pointer hover:text-[#a27f59] text-[#866d4f]"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex items-center justify-between">
            <p className="text-xl [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
              {item.question ?? "-"}
            </p>
            <motion.div
              initial={{ rotate: 0 }}
              animate={{ rotate: questionSelected === item.id ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              {questionSelected === item.id ? (
                <FaArrowUp size={30} />
              ) : (
                <FaArrowDown size={30} />
              )}
            </motion.div>
          </div>

          {questionSelected === item.id && (
            <motion.div
              className="text-[#262626] mt-4 ml-4"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: item.answer ?? "-" }}
              ></div>
            </motion.div>
          )}
        </motion.div>
      ))}
    </>
  );
};

export default ListQuestionsFaq;
